import { forwardRef } from "react";
import { CircularProgress } from "@mui/material";

const Button = forwardRef(function Button({ type = "button", children, className = "", loading, ...props }, ref) {
  return (
    <button ref={ref} type={type} className={"btn " + className} disabled={loading} {...props}>
      {loading ? <CircularProgress size={25} color="inherit" /> : children}
    </button>
  );
});

export default Button;
